import { render } from "./SixDigitAuth.vue?vue&type=template&id=67a00900&scoped=true"
import script from "./SixDigitAuth.vue?vue&type=script&lang=js"
export * from "./SixDigitAuth.vue?vue&type=script&lang=js"

import "./SixDigitAuth.vue?vue&type=style&index=0&id=67a00900&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a00900"]])

export default __exports__